import React, { useEffect } from 'react'
import { DatePickerSeeker, disabledBeforeToday } from '@ui-seeker/core'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData, useCsv } from 'Pages/ReportsAlerts/Reports/@signals'
import { object, string } from 'yup'
import { isEmpty } from '@ui-seeker/utils'
import { parseBackendDate } from '@utils'


export default function TerminationDateField() {


	const {
		terminationDate,
		setTerminationDateInfo,
		error,
	} = useReportFormInfo(parseBackendDate(reportFormData.peek().terminationDate), 'terminationDate', object({ terminationDate: string().nullable() }), true)

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setTerminationDateInfo(null, false)
		}
	}, [useCsv.value])

	return <DatePickerSeeker
		cleanable
		inputProps={{ sx: { backgroundColor: 'background.grey' } }}
		label="Termination date"
		shouldDisableDate={disabledBeforeToday()}
		value={terminationDate}
		onChange={e => setTerminationDateInfo(e)}
		error={error}
	/>
}